import React from 'react';
export const { Provider, Consumer } = React.createContext()


// WEBPACK FOOTER //
// ./src/context/InfoContext.js